import(/* webpackMode: "eager" */ "/vercel/path0/src/app/produto/[slug]/error.tsx");
